import React from "react";
import {
  LoginContainer,
  LoginImageSection,
  BrandLogo,
  ImageWrapper,
  LoginFormSection,
  LoginCard,
  LoginForm,
  MicrosoftButton,
  WelcomeText,
  SubText,
} from "./Login.styled";
import Modal from "../../components/Modal/Modal";
import { useLoginService } from "./LoginService";

const Login = () => {
  const { modal, handleMicrosoftLogin, handleCloseModal } = useLoginService();

  return (
    <LoginContainer>
      <LoginImageSection>
        <BrandLogo>FlashTrack</BrandLogo>
        <ImageWrapper>
          <img
            src="/assets/login-illustration.svg"
            alt="Login illustration"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </ImageWrapper>
      </LoginImageSection>

      <LoginFormSection>
        {modal && (
          <Modal
            type={modal.type}
            title={modal.title}
            message={modal.message}
            onClose={handleCloseModal}
          />
        )}
        <LoginCard>
          <LoginForm>
            <WelcomeText>Welcome Back</WelcomeText>
            <SubText>Sign in to access your FlashTrack account</SubText>

            <MicrosoftButton
              type="button"
              onClick={handleMicrosoftLogin}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <img
                src="/assets/microsoft-logo.svg"
                alt="Microsoft"
                width="24"
                height="24"
                style={{ marginRight: "12px" }}
              />
              Sign in with Microsoft
            </MicrosoftButton>
          </LoginForm>
        </LoginCard>
      </LoginFormSection>
    </LoginContainer>
  );
};

export default Login;
